import { graphql } from '@prophecy/graphql-types/graphql';

export const AllUserQuery = graphql(`
  query AllUsers {
    allUsers {
      _id
      email
      attributes
      created
    }
  }
`);

export const AllTeamsQuery = graphql(`
  query tableQueryTeam {
    allTeams(includePersonalTeams: true) {
      _id
      name
      createdBy
      copilotEnabled
      created
      teamState
      admins {
        _id
      }
    }
  }
`);

export const UpdateCopilotEnabledMutationQuery = graphql(`
  mutation updateCopilotEnabled($teamUID: String!, $enabled: Boolean!) {
    updateCopilotEnabled(teamUID: $teamUID, copilotEnabled: $enabled)
  }
`);

export const AllFabricsQuery = graphql(`
  query tableQueryFabric {
    allFabrics {
      SparkProviderInfoAspect: aspects(aspect: SparkProviderInfo) {
        AspectValue
        AspectName
      }
      SqlProviderInfoAspect: aspects(aspect: SqlProviderInfo) {
        AspectValue
        AspectName
      }
      DQProviderInfoAspect: aspects(aspect: DQProviderInfo) {
        AspectValue
        AspectName
      }
      AirflowProviderInfoAspect: aspects(aspect: AirflowProviderInfo) {
        AspectValue
        AspectName
      }
      _id
      FabricServicePrincipalStateAspect: aspects(aspect: FabricServicePrincipalState) {
        AspectValue
        AspectName
      }
      name
      InfoAspect: aspects(aspect: Info) {
        AspectValue
        AspectName
      }
      createdBy
      team {
        _id
        name
      }
      created
    }
  }
`);

export const ClusterTeamMembersQuery = graphql(`
  query tableQueryMember($uid: String!) {
    Team(uid: $uid) {
      members {
        _id
        firstName
        lastName
        email
        created
      }
    }
  }
`);

export const GetDefaultTemplateQuery = graphql(`
  query defaultTemplate($language: BackEndCodeLanguage, $buildSystem: BuildSystem) {
    getDefaultTemplate(language: $language, buildSystem: $buildSystem)
  }
`);

export const SetDefaultTemplateMutationQuery = graphql(`
  mutation defaultTemplate($language: BackEndCodeLanguage!, $buildSystem: BuildSystem!, $content: String!) {
    updateDefaultTemplate(language: $language, buildSystem: $buildSystem, content: $content)
  }
`);
